var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-toggle-side-bar btn-outline-dark",on:{"click":_vm.toggleSideBar}},[_c('font-awesome-icon',{attrs:{"icon":"bars"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }